import { render } from "./Footer.vue?vue&type=template&id=36963829&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=36963829&lang=scss&scoped=true"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36963829"]])

export default __exports__